import { render, staticRenderFns } from "./ChatToolbar.vue?vue&type=template&id=162f486e&scoped=true&"
import script from "./ChatToolbar.vue?vue&type=script&lang=js&"
export * from "./ChatToolbar.vue?vue&type=script&lang=js&"
import style0 from "./ChatToolbar.vue?vue&type=style&index=0&id=162f486e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162f486e",
  null
  
)

export default component.exports